/* ===================================================================
   Stand Popup – per-stand image gallery with swipe on mobile
   =================================================================== */

(function () {
  'use strict';

  let rootEl = null;
  let standsData = [];

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const root = document.getElementById('stand-popup-root');
    if (!root) return;

    let stands = [];
    try { stands = JSON.parse(root.dataset.stands || '[]'); } catch(e) { return; }
    if (!stands.length) return;

    rootEl = root;
    standsData = stands;

    setText('#cm-label', root.dataset.popupLabel);
    setText('#cm-notice', root.dataset.notice);

    buildTabs(stands, root);

    // Luk
    root.querySelectorAll('[data-stand-close]').forEach(el => {
      el.addEventListener('click', () => closePopup(root));
    });
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Escape' && root.style.display !== 'none') closePopup(root);
    });

    // Variant-skift → synk aktiv stand
    document.addEventListener('change', (e) => {
      const input = e.target.closest('input[type="radio"]');
      if (!input) return;
      const fieldset = input.closest('fieldset');
      if (!fieldset) return;
      const legend = fieldset.querySelector('.product-form__group-name, legend, label');
      if (!legend) return;
      if (legend.textContent.replace(':', '').trim().toLowerCase() !== 'stand') return;
      const idx = stands.findIndex(s => s.title.toLowerCase() === input.value.toLowerCase());
      if (idx !== -1) showStand(stands[idx], idx, root);
    });

    // Inject "Læs mere"
    injectReadMore(stands, root.dataset.readMore || 'Læs mere', root);
  }

  /* -------------------------------------------------------
     Byg tabs
  ------------------------------------------------------- */
  function buildTabs(stands, root) {
    const container = document.getElementById('cm-tabs');
    if (!container) return;
    container.innerHTML = '';

    stands.forEach((stand, i) => {
      if (!stand.title) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = stand.title;
      if (i === 0) btn.classList.add('active');
      btn.addEventListener('click', () => showStand(stand, i, root));
      container.appendChild(btn);
    });
  }

  /* -------------------------------------------------------
     Vis stand – opdater galleri, titel, beskrivelse, badges
  ------------------------------------------------------- */
  function showStand(stand, idx, root) {
    // Aktiv tab
    document.querySelectorAll('#cm-tabs button').forEach((btn, i) => {
      btn.classList.toggle('active', i === idx);
    });

    // Byg billede-galleri
    buildGallery(stand);

    // Titel + beskrivelse
    setText('#cm-title', stand.title);
    const maxChars = 300;
    const desc = stand.description || '';
    const truncated = desc.length > maxChars ? desc.slice(0, maxChars).trimEnd() + '…' : desc;
    setText('#cm-description', truncated);

    // Badges
    updateBadges(stand, root);
  }

  /* -------------------------------------------------------
     Byg billede-galleri for valgt stand
  ------------------------------------------------------- */
  function buildGallery(stand) {
    const gallery = document.getElementById('cm-gallery');
    const dotsEl  = document.getElementById('cm-dots');
    if (!gallery) return;

    gallery.innerHTML = '';
    if (dotsEl) dotsEl.innerHTML = '';

    const images = [];
    if (stand.image && stand.image !== '//') images.push('https:' + stand.image);
    if (stand.image_mobile && stand.image_mobile !== '//') images.push('https:' + stand.image_mobile);

    if (!images.length) {
      if (document.getElementById('cm-gallery-wrap')) {
        document.getElementById('cm-gallery-wrap').style.display = 'none';
      }
      return;
    }
    if (document.getElementById('cm-gallery-wrap')) {
      document.getElementById('cm-gallery-wrap').style.display = '';
    }

    images.forEach((src, i) => {
      const div = document.createElement('div');
      div.className = 'cm-gallery-img';
      const img = document.createElement('img');
      img.src = src;
      img.alt = stand.title + (i === 1 ? ' – eksempel 2' : '');
      img.loading = i === 0 ? 'eager' : 'lazy';
      div.appendChild(img);
      gallery.appendChild(div);

      // Dots (kun hvis mere end ét billede)
      if (images.length > 1 && dotsEl) {
        const dot = document.createElement('div');
        dot.className = 'cm-dot' + (i === 0 ? ' is-active' : '');
        dot.addEventListener('click', () => {
          currentIdx = i;
          scrollGalleryTo(i);
          updateDots(i);
        });
        dotsEl.appendChild(dot);
      }
    });

    // Observer for dot-sync ved swipe
    let currentIdx = 0;
    const updateArrows = () => {
      const prevBtn = document.getElementById('cm-prev');
      const nextBtn = document.getElementById('cm-next');
      if (prevBtn) prevBtn.toggleAttribute('hidden', currentIdx === 0);
      if (nextBtn) nextBtn.toggleAttribute('hidden', currentIdx === images.length - 1);
    };
    updateArrows();

    // Pile
    const prevBtn = document.getElementById('cm-prev');
    const nextBtn = document.getElementById('cm-next');
    if (prevBtn) {
      prevBtn.onclick = () => { if (currentIdx > 0) { currentIdx--; scrollGalleryTo(currentIdx); updateArrows(); updateDots(currentIdx); } };
    }
    if (nextBtn) {
      nextBtn.onclick = () => { if (currentIdx < images.length - 1) { currentIdx++; scrollGalleryTo(currentIdx); updateArrows(); updateDots(currentIdx); } };
    }

    if (images.length > 1) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            const imgs = gallery.querySelectorAll('.cm-gallery-img');
            imgs.forEach((el, i) => {
              if (el === entry.target) {
                currentIdx = i;
                updateDots(i);
                updateArrows();
              }
            });
          }
        });
      }, { root: gallery, threshold: 0.5 });

      gallery.querySelectorAll('.cm-gallery-img').forEach(el => observer.observe(el));
    }
  }

  function updateDots(activeIdx) {
    const dotsEl = document.getElementById('cm-dots');
    if (!dotsEl) return;
    dotsEl.querySelectorAll('.cm-dot').forEach((d, i) => {
      d.classList.toggle('is-active', i === activeIdx);
    });
  }

  function scrollGalleryTo(idx) {
    const gallery = document.getElementById('cm-gallery');
    const imgs = gallery?.querySelectorAll('.cm-gallery-img');
    if (imgs && imgs[idx]) {
      imgs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  /* -------------------------------------------------------
     Badges per stand
  ------------------------------------------------------- */
  function updateBadges(stand, root) {
    const footer = document.getElementById('cm-footer');
    if (!footer) return;
    footer.innerHTML = '';
    [root.dataset.badge1, stand.battery || root.dataset.badge2, root.dataset.badge3].forEach(text => {
      if (!text) return;
      const div = document.createElement('div');
      div.className = 'condition-modal__badge';
      div.textContent = text;
      footer.appendChild(div);
    });
  }

  /* -------------------------------------------------------
     Åbn popup
  ------------------------------------------------------- */
  function openPopup(root, stands, currentStand) {
    if (root.parentElement !== document.body) document.body.appendChild(root);
    root.style.display = 'block';

    const idx = Math.max(0, stands.findIndex(s =>
      s.title.toLowerCase() === (currentStand || '').toLowerCase()
    ));

    showStand(stands[idx], idx, root);

    // Scroll lock
    const scrollY = window.scrollY;
    document.body.dataset.standScrollY = scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  /* -------------------------------------------------------
     Luk popup
  ------------------------------------------------------- */
  function closePopup(root) {
    root.style.display = 'none';
    const scrollY = parseInt(document.body.dataset.standScrollY || '0');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    delete document.body.dataset.standScrollY;
    window.scrollTo(0, scrollY);
  }

  /* -------------------------------------------------------
     Inject "Læs mere"
  ------------------------------------------------------- */
  function injectReadMore(stands, readMoreText, root) {
    let attempts = 0;
    const tryInject = setInterval(() => {
      const legends = document.querySelectorAll(
        '.product-form__group-name, .product-form__controls legend, legend'
      );
      let standLegend = null;
      legends.forEach(el => {
        if (el.textContent.replace(':', '').trim().toLowerCase() === 'stand') {
          standLegend = el;
        }
      });

      if (standLegend && !standLegend.querySelector('.stand-read-more')) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'stand-read-more';
        btn.textContent = readMoreText;
        btn.addEventListener('click', () => {
          const checked = document.querySelector('input[type="radio"]:checked');
          const currentStand = checked?.value || stands[0]?.title || '';
          openPopup(root, stands, currentStand);
        });
        standLegend.appendChild(btn);
        clearInterval(tryInject);
      }
      if (++attempts > 30) clearInterval(tryInject);
    }, 200);
  }

  window.addEventListener('pagehide', () => {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.overflow = '';
  });

  function setText(selector, text) {
    const el = document.querySelector(selector);
    if (el && text !== undefined) el.textContent = text;
  }

})();
